import axios from 'axios'
import { API_URL } from '../constants/linksApi'

export const api = axios.create({
    baseURL: API_URL + '/cms',
    timeout: 5000,
})
